import React, { Fragment } from 'react'
import { Container, Col, Row, Button, Card, CardBody, Input } from 'reactstrap';
import { ModalAntibiotic } from '../../../components/micro/antibiotic/ModalAntibiotic';
import { useAntibiotic } from '../../../hooks/micro/useAntibiotic';
import { AlertDataTable } from '../../../components/tableDataTable/AlertDataTable';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export const IndexAntibiotic = () => {

    const {
        antibiotics, method, validaciones,
        antibiotic,
        handleInputChange, loading,
        toggle, modal, modalTitle,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        handleSearch,
        showDeleteAlert, modalAlert,
        closeDeleteAlert, closeDialog,
        handleExportExcelMorphology, loadingExport, handleClearAntibiotic,
        searchAntibiotic, aware
    } = useAntibiotic();
    console.log("🍩 antibiotics", antibiotics);


    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>

                <Button
                    color="primary"
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_mic_antibiotic)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}

                >
                    <i className="fa fa-edit"></i>
                </Button>


                <Button
                    color="danger"
                    size="sm"
                    onClick={() => handleDelete(rowData.id_mic_antibiotic)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </Button>
            </div>
        );
    };

    const awareTemplate = (rowData) => {
        let color = "";
        let labelAware = "";

        switch (rowData.aware) {
            case 1:
                color = "#a2ff6f";
                labelAware = "A"
                break;

            case 2:
                color = "#f5f48f";
                labelAware = "W";
                break;

            case 3:
                color = "#f6b4b4";
                labelAware = "R";
                break;

            case 4:
                color = "";
                labelAware = "";
                break;
            default:
                color = "";
                labelAware = "";
                break;

        }
        return (
            <span style={{ backgroundColor: color, padding: "4px 8px", borderRadius: "5px" }}>
                <strong>{labelAware}</strong>

            </span>
        )
    }

    return (
        <Fragment>
            <div className='container-global-zoom'>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody className="p-1">
                                <Col sm="12" className='p-l-0 p-r-0 pb-2 pt -3' >
                                    <TitleDataTable
                                        titleTable="Listado de antibióticos"
                                        buttonActions={handleExportExcelMorphology}
                                        titleButton="Listado de antibióticos"
                                        isDisbled={loadingExport}
                                        loadingIsDisabled={loadingExport}
                                        titleCreate="Crear Laboratorio"
                                        buttonActionsCreate={handleCreate}
                                        actionInput={handleSearch}
                                        valueFilter={searchAntibiotic}
                                        filterLocalStorage={true}
                                        cleanFilterLocalStorage={handleClearAntibiotic}

                                    />
                                </Col>

                                <div className="table-responsive">
                                    <DataTable
                                        value={antibiotics}
                                        paginator
                                        rows={10}
                                        responsiveLayout="scroll"
                                        rowsPerPageOptions={[10, 50, 100]}
                                        className="data-table p-datatable-striped p-datatable-sm"
                                        emptyMessage={
                                            <div className="text-center">
                                                <img
                                                    src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                    style={{ width: "32%" }}
                                                    alt="Sin resultados"
                                                />
                                                <br />
                                                <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                    No se encontraron resultados.
                                                </p>
                                            </div>
                                        }
                                    >

                                        <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                        <Column field="antibiotic" header="Antibióticos" headerStyle={headerStyle} style={cellStyle} />
                                        <Column field="aware" header="AWARE" body={awareTemplate} headerStyle={headerStyle} style={cellStyle} />
                                        <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                    </DataTable>
                                </div>

                            </CardBody>
                        </Card>

                        {showDeleteAlert && (
                            <AlertDataTable
                                titleAlert="Eliminar Antibióticos"
                                visibleAlert={modalAlert}
                                onHideAlert={closeDeleteAlert}
                                sizeAlert="medium-dialog delete-method"
                                messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar el antibióticos?"
                                alert1={true}
                                titleAlert1={antibiotic}
                                buttonAcept
                                titleNotLoading="Eliminar"
                                titleDanger="Cancelar"
                                actionAcept={saveDelete}

                            />

                        )}

                        <ModalAntibiotic
                            {...{
                                modal, modalTitle, toggle, method,
                                validaciones,
                                antibiotic,
                                handleInputChange, loading,
                                saveCreate, saveUpdate, saveDelete,
                                closeDialog, aware
                            }}
                        />
                    </Col>
                </Row>
            </div>
        </Fragment>
    )
}
